module.exports = __webpack_public_path__ + "media/images/850/insomnia_moon_dark_skies-c6413e0b2a4097642ecd9369ca38245f.webp";